/* globals _, jQuery */

import Model from './framework/models/base';
import Session from './framework/models/session';

import App from './framework/views/app';

import setupShared from './setup/shared';
import setupViews from './setup/views';
import setupRouter from './setup/router';
import setupFetching from './setup/fetching';
import setupEditors from './setup/editors';
import setupMaps from './setup/maps';
import setupFiltering from './setup/filtering';
import setupItinerary from './setup/itinerary';
import setupAuth from './setup/auth';

import cssTest from './utilities/css-test';

const supportsAnimation = cssTest.supports.animation;
const animationEndEvent = cssTest.endEvent.animation;

const { noop } = _;

const storage = window.localStorage || {
	getItem: () => null,
	setItem: () => void 0,
};

const FLUTTERBOUT_VERSION = '201910170935';

( function( $ ) {
	$.fn.fill = function( content, attr ) {
		return $( this ).each( function() {
			var $elm = $( this );
			if ( $elm.find( '.fill' ).length > 0 ) {
				$elm = $elm.find( '.fill' );
			}

			if ( attr ) {
				$elm.attr( attr, content );
			} else
			if ( typeof $elm[0].value !== 'undefined' ) {
				$elm.val( content );
			} else {
				$elm.text( content );
			}
		} );
	};

	function makeViewToggle( startEvent, endEvent, addClass, removeClass ) {
		return function ( callback ) {
			callback = callback || noop;

			return $( this ).each( function() {
				var $this = $( this );

				$this.trigger( startEvent );

				if ( ! supportsAnimation || $this.css( 'animation-duration' ) === '0s' || $this.hasClass( addClass ) ) {
					$this.addClass( addClass ).removeClass( removeClass );
					$this.trigger( endEvent );
					callback();
					return;
				}

				var onEnd = e => {
					if ( $this.is( e.target ) ) {
						$this.off( animationEndEvent, onEnd );
						$this.removeClass( 'animate' );
						$this.trigger( endEvent );
						callback();
					}
				};

				$this.on( animationEndEvent, onEnd );
				$this.addClass( 'animate' ).addClass( addClass ).removeClass( removeClass );
			} );
		}
	}

	$.fn.showView = makeViewToggle( 'showing', 'shown', 'in', 'out' );
	$.fn.hideView = makeViewToggle( 'hiding', 'hidden', 'out', 'in' );
} )( jQuery );

var savedSession = storage.getItem( 'session' ) || '{}';
try {
	savedSession = JSON.parse( savedSession );
} catch ( err ) {
	savedSession = {};
}

if ( savedSession.v !== FLUTTERBOUT_VERSION ) {
	savedSession = {
		v: FLUTTERBOUT_VERSION,
		request: 'area',
		mode: 'driving',
		start: '09:00',
		end: '17:00',
		date: '',
		origin: '',
		destination: '',
		area: 20,
	};
}

var session = new Session( savedSession );

session.on( 'change', function() {
	storage.setItem( 'session', JSON.stringify( this.dump() ) );
} );

var app = new App( {
	model: session,
	el: '#app',
} );

app.profile = new Model();

window.flutterDebug = function( context, data ) {
	console.log( context, data );
	document.getElementById( 'debug_log' ).innerHTML += ( context + ':' + JSON.stringify( data ) + '\n' );
};

app.render();

jQuery( $ => {
	setupShared( $, app );
	setupViews( $, app );
	setupFetching( $, app );
	setupRouter( $, app );
	setupEditors( $, app );
	setupItinerary( $, app );
} );

window.initMap = function() {
	jQuery( $ => {
		setupMaps( $, app );
		setupFiltering( $, app );
	} );
};

window.setClientCoordinates = function( data ) {
	app.coords = data;

	flutterDebug( 'coords', data );

	return data && data.latitude && data.longitude;
};

window.toggleOauthSupport = function( supported ) {
	document.body.classList.toggle( 'supports-oauth', supported );
};

const authMethods = setupAuth( jQuery, app );
window.googleAsyncInit = authMethods.google;
window.fbAsyncInit = authMethods.facebook;

window.Flutterbout = app;
